// Një vend i vetëm për çdo gjë që ndryshon pa prekur kodin.

const config = {
  brand: {
    name: "Aroma Stick",
    tagline: "Fuqia e natyrës, në xhepin tënd",
  },

  // Numri i WhatsApp në format ndërkombëtar, pa "+" dhe pa hapësira.
  whatsappNumber: "38346844484",

  // Teksti që mbushet automatikisht kur klienti hap WhatsApp.
  whatsappMessage: "Përshëndetje! Dua të porosis një Aroma Stick.",

  // Çmimi dhe oferta — ndryshohen vetëm këtu.
  price: "9.90€",
  shipping: "Transport falas",
  bundle: "Bli 3, merr 1 falas",

  social: {
    instagram: "https://www.instagram.com/aromastick.ks/",
    facebook: "https://www.facebook.com/profile.php?id=61572259483179",
    tiktok: "https://www.tiktok.com/@aromastick_ks",
  },

  email: "info@aromastick.com",
};

export const whatsappLink = (text) =>
  `https://wa.me/${config.whatsappNumber}?text=${encodeURIComponent(
    text || config.whatsappMessage,
  )}`;

export default config;
